import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { ContentSlotComponent } from 'ish-shared/cms/components/content-slot/content-slot.component';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';

@Component({
  selector: 'ish-cms-dialog',
  templateUrl: './cms-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContentSlotComponent, ServerHtmlDirective],
})
export class CMSDialogComponent implements CMSComponent {
  readonly pagelet = input<ContentPageletView>(undefined);
}
